import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PAGLogin = () => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSignUp, setIsSignUp] = useState(false);
  const navigate = useNavigate();
  const [success, setSuccess] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      setError("Both email and password fields are required.");
      return;
    }
  
    try {
      // First, get the access token
      const tokenData = new URLSearchParams({
        grant_type: "http://auth0.com/oauth/grant-type/password-realm",
        username: email,
        password: password,
        audience: "https://pag-optimus.us.auth0.com/api/v2/",
        client_id: "oD6nKU2OG42gzhFk8inXv7BBAOysIoe7",
        realm: "Username-Password-Authentication",
        scope: "openid profile email",
      });
  
      const response = await fetch("https://pag-optimus.us.auth0.com/oauth/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "application/json",
        },
        body: tokenData,
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error_description || "Login failed");
      }

      // Get Management API token to fetch user details with metadata and roles
      const mgmtTokenResponse = await fetch("https://pag-optimus.us.auth0.com/oauth/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          client_id: "6PSiydOrLO17cBFQNVlWPRKGW6ky1BUN",
          client_secret: "j_yvFASXENX0Y785_Kbd7RCZbFbGi5qFapXs8tN0CQvBrk9-I8DYJ_KBnZZu6BeH",
          audience: "https://pag-optimus.us.auth0.com/api/v2/",
          grant_type: "client_credentials",
        }),
      });

      const mgmtTokenData = await mgmtTokenResponse.json();
  
      // Get basic user info first
      const userResponse = await fetch("https://pag-optimus.us.auth0.com/userinfo", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.access_token}`,
        },
      });
  
      const userData = await userResponse.json();

      // Get detailed user info with metadata using Management API
      const userDetailResponse = await fetch(`https://pag-optimus.us.auth0.com/api/v2/users/${encodeURIComponent(userData.sub)}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${mgmtTokenData.access_token}`,
        },
      });

      const userDetailData = await userDetailResponse.json();

      // Get user roles
      const userRolesResponse = await fetch(`https://pag-optimus.us.auth0.com/api/v2/users/${encodeURIComponent(userData.sub)}/roles`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${mgmtTokenData.access_token}`,
        },
      });

      const userRoles = await userRolesResponse.json();
      
      console.log("Full user data:", userDetailData);
      console.log("User roles:", userRoles);

      // Determine user role based on role IDs
      let userRole = "User"; // default
      if (userRoles && userRoles.length > 0) {
        const roleId = userRoles[0].id;
        if (roleId === "rol_cVlQ62sWUUo78hWU") {
          userRole = "Global Admin";
        } else if (roleId === "rol_jJumRGs15KKWFoNK") {
          userRole = "Admin";
        } else if (roleId === "rol_WkO6eoKdFCYNVr7F") {
          userRole = "User";
        }
      }
  
      // Extract username from metadata or fallback to email
      const storedUsername = userDetailData.user_metadata?.username || 
                            userDetailData.username || 
                            userData.email.split("@")[0];
  
      // Store user details in localStorage
      localStorage.setItem("user", JSON.stringify({
        username: storedUsername,
        email: userData.email,
        role: userRole,
        roleId: userRoles?.[0]?.id || null,
      }));
      
      localStorage.setItem("access_token", data.access_token);
      
      console.log("User info saved:", storedUsername, userData.email, userRole); 
  
      navigate("/dashboard");
    } catch (error) {
      setError(error.message || "Login failed. Please try again.");
    }
  };
  
  const handleSignUp = async () => {
    if (!email || !password || !username) {
      setError("All fields are required.");
      return;
    }

    const usernameRegex = /^[a-zA-Z0-9_+\-\.!#$'^`~@]+$/;
if (!usernameRegex.test(username)) {
  setError("Error! Username can only contain letters, numbers, and these characters: _ + - . ! # $ ' ^ ` ~ @");
  return;
}

    try {
      const signUpData = {
        client_id: "oD6nKU2OG42gzhFk8inXv7BBAOysIoe7",
        email: email,
        password: password,
        username: username, 
        connection: "Username-Password-Authentication",
        user_metadata: { username: username },
      };

      const response = await fetch("https://pag-optimus.us.auth0.com/dbconnections/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signUpData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "User already exists. Please log in.");
      }

      console.log("Sign-Up successful! Username stored:", username);

      // Assign default User role to new user
const mgmtTokenResponse = await fetch("https://pag-optimus.us.auth0.com/oauth/token", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    client_id: "6PSiydOrLO17cBFQNVlWPRKGW6ky1BUN",
    client_secret: "j_yvFASXENX0Y785_Kbd7RCZbFbGi5qFapXs8tN0CQvBrk9-I8DYJ_KBnZZu6BeH",
    audience: "https://pag-optimus.us.auth0.com/api/v2/",
    grant_type: "client_credentials",
  }),
});

const mgmtTokenData = await mgmtTokenResponse.json();

// Get the user ID from the signup response
const userIdResponse = await fetch(`https://pag-optimus.us.auth0.com/api/v2/users-by-email?email=${encodeURIComponent(email)}`, {
  method: "GET",
  headers: {
    Authorization: `Bearer ${mgmtTokenData.access_token}`,
  },
});

const userDataArray = await userIdResponse.json();
const newUserId = userDataArray[0].user_id;

// Assign User role (rol_WkO6eoKdFCYNVr7F)
await fetch(`https://pag-optimus.us.auth0.com/api/v2/users/${newUserId}/roles`, {
  method: 'POST',
  headers: { 
    Authorization: `Bearer ${mgmtTokenData.access_token}`,
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    roles: ["rol_WkO6eoKdFCYNVr7F"] // User role ID
  }),
});
      
      // Show success message and switch to login
      setSuccess("Sign-Up successful! Please log in.");
      setError("");
      setIsSignUp(false);

      // Reset form fields after successful signup
      setEmail("");
      setPassword("");
      setUsername("");

    } catch (error) {
      setError(error.message || "Sign-up failed. Please try again.");
    }
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-100">
      {/* Logo */}
      <img
        src="/PAG.png"
        alt="PAG Logo"
        className="md:w-[220px] sm:w-[180px] w-[120px] pl-8 h-auto mx-auto mb-14"
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
  
      {/* Login/Signup Box */}
      <div className="border border-gray-300 shadow-md bg-white p-8 rounded-xl text-center md:w-[500px] sm:w-[490px] w-[340px]">
        <p className="text-gray-700 text-lg font-semibold mb-6">
          {isSignUp ? "Sign Up" : "Login"}
        </p>
  
        {/* Error Message */}
{error && <p className="text-red-500 text-sm mb-4">{error}</p>}
{/* Success Message */}
{success && <p className="text-green-500 text-sm mb-4">{success}</p>}
  
        {/* Username Field (Only in Sign-Up Mode) */}
        {isSignUp && (
          <div className="mb-4 text-left">
            <label className="block mb-2 text-sm font-bold" htmlFor="username">
              Username
            </label>
            <input
              className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#a32b13]"
              id="username"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
        )}
  
        {/* Email Field */}
        <div className="mb-4 text-left">
          <label className="block mb-2 text-sm font-bold" htmlFor="email">
            Email Address
          </label>
          <input
            className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#a32b13]"
            id="email"
            type="email"
            placeholder="name@address.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
  
        {/* Password Field */}
        <div className="mb-6 text-left">
          <label className="block mb-2 text-sm font-bold" htmlFor="password">
            Password
          </label>
          <input
            className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#a32b13]"
            id="password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
  
        {/* Login/Sign-Up Button */}
        <button
          className="bg-[#a32b13] text-white font-bold py-2 w-full rounded-lg hover:bg-[#8a2410] transition duration-200"
          onClick={isSignUp ? handleSignUp : handleLogin}
        >
          {isSignUp ? "Sign Up" : "Login"}
        </button>
  
        {/* Toggle Between Login & Sign Up */} 
         <p className="text-sm text-gray-600 mt-4">
          {isSignUp ? "Already have an account? " : "Don't have an account? "}
          <span
            className="text-[#a32b13] underline cursor-pointer hover:underline"
            onClick={() => {
              setIsSignUp(!isSignUp);
              setSuccess("");
              setError("");
              setEmail("");
              setPassword("");
              setUsername("");
            }}
          >
            {isSignUp ? "Login" : "Sign Up"}
          </span>
        </p>
      </div>
    </div>
  );
};

export default PAGLogin;